export default __webpack_public_path__ + "static/media/unstar.6716962f.svg";